import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    actionCheckNoticeSearch,
    actionCheckNoticeUpdate,
    actionNoticeListSearch,
} from '../../module/modal/EnrolmentCautionModule';
import { CODE_GROUP_ID, NOTICE_CHECK_STATUS_CD } from '../../constant/Constant';
import { ModalHeader } from '../../component/ModalRef';
import PopupRef from '../../component/PopupRef';
import NullCheckUtil from '../../util/NullCheckUtil';
import TabBox from '../../component/TabBox';
import TextViewer from '../../component/editor/TextViewer';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import CheckBox from '../../component/CheckBox';
import CodeUtil from '../../util/CodeUtil';
import SemesterUtil from '../../util/SemesterUtil';

const EnrolmentUnivCautionModal = ({ userId, isEnrolment = false, modalRef }) => {
    const dispatch = useDispatch();
    const { semesterUser, notification } = useSelector((state) => state.enrolmentCautionState);
    const [checked, setChecked] = useState(false);
    const tab = useRef(null);

    const popupRef = useRef(null);

    useEffect(() => {
        if (isEnrolment) {
            dispatch(actionCheckNoticeSearch({ params: { userId } }));
        }

        dispatch(actionNoticeListSearch({}));
    }, []);

    useEffect(() => {
        var defaultTabNo = 0;

        if (NullCheckUtil.isNotEmpty(notification)) {
            tab.current.initTab(
                notification.map((item, index) => {
                    return {
                        tabNo: index,
                        title:
                            item.mainUniversityCd == 'COMMON'
                                ? '공통'
                                : `${CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, item.mainUniversityCd)}`,

                        element: <TextViewer key={index} tabNo={index} value={item.enrolmentNotice} />,
                    };
                }),
                defaultTabNo,
            );
        } else {
            tab.current.initTab(
                [
                    {
                        tabNo: 0,
                        title: '공통',
                        element: <TextViewer key={0} tabNo={0} value={'등록된 수강신청 유의사항이 없습니다.'} />,
                    },
                ],
                defaultTabNo,
            );
        }
    }, [notification]);

    useEffect(() => {
        if (isEnrolment) {
            if (NullCheckUtil.isNotNull(semesterUser)) {
                if (NOTICE_CHECK_STATUS_CD.CONFIRM == semesterUser.noticeCheckStatusCd) {
                    setChecked(true);
                } else {
                    setChecked(false);
                }
            } else {
                setChecked(false);
            }
        }
    }, [semesterUser]);

    const handleCancel = (e) => {
        modalRef.current.close();
    };

    const handleConfirm = (e) => {
        if (isEnrolment) {
            if (checked) {
                dispatch(
                    actionCheckNoticeUpdate({
                        params: { userId },
                        callback: () => {
                            popupRef.current.openAlert('수강신청 유의사항 동의여부가 처리되었습니다.', () => {
                                return function () {
                                    modalRef.current.close();
                                };
                            });
                        },
                    }),
                );
            } else {
                popupRef.current.openWarning('수강신청 유의사항에 동의하지 않으면 수강신청이 불가합니다.');
            }
        } else {
            modalRef.current.close();
        }
    };

    return (
        <>
            <ModalHeader title='대학별 수강신청 유의사항' modalRef={modalRef} />
            <div className='modal-body'>
                <div className='notice-popup-inner'>
                    <p className='info-icon-txt'>
                        각 대학의 수강신청 기간 및 유의사항을 확인하여 수강신청하기 바랍니다.
                    </p>

                    <div className='caution-modal'>
                        <TabBox ref={tab} />
                    </div>
                </div>

                {isEnrolment ? (
                    <div className='notice-check'>
                        <CheckBox
                            checked={checked}
                            onChecked={setChecked}
                            span='안내사항을 확인하였으며, 이에 동의합니다.'
                        />
                    </div>
                ) : (
                    <></>
                )}

                <div className='modal-btn-wrap'>
                    {isEnrolment ? <CancelButtonBox title='취소' onClick={(e) => handleCancel()} /> : <></>}
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default EnrolmentUnivCautionModal;
